import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://restaurantenglishready.impultienda.ar/checkout';
type CtaButtonProps = {
  label?: string;
  href?: string;
  className?: string;
};
export function CtaButton({
  label = 'Get My Full-Year Kit',
  href = CHECKOUT_URL,
  className = ''
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  let destination = href;
  if (!isInternal && typeof window !== 'undefined') {
    const checkout = new URL(href);
    new URLSearchParams(window.location.search).forEach((value, key) => {
      if (key.startsWith('utm_') || key === 'fbclid') checkout.searchParams.set(key, value);
    });
    destination = checkout.toString();
  }
  return <a href={destination} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`group mt-2.5 inline-flex items-center justify-center gap-3 rounded-full bg-red-500 px-[35px] py-7 text-center text-sm font-extrabold uppercase leading-none text-white shadow-xl transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-red-600 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-500/30 sm:text-base ${className}`} data-id="element-36" data-mp="vclfw6ib4lle">
      <span className="-mr-[0.12em] tracking-[0.12em]" data-id="element-37" data-mp="3ew9i2piafhk5">{label}</span>
      <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-38" data-mp="3jx76hjtw57u3" />
    </a>;
}